import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminPage from "./components/AdminPage";
import Gallery from "./components/Gallery";
import Realisations from "./pages/Realisations";
import "./App.css";

function App() {
  useEffect(() => {
    // Navbar scroll effect
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (navbar) {
        // Ne pas appliquer l'effet scrolled sur mobile
        if (window.innerWidth > 768) {
          if (window.scrollY > 50) {
            navbar.classList.add("scrolled");
          } else {
            navbar.classList.remove("scrolled");
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Router>
      <Routes>
        {/* Page principale */}
        <Route
          path="/"
          element={
            <div className="App">
              <Navbar />
              <Hero />
              <Stats />
              <Services />
              <Gallery />
              <About />
              <Contact />
              <Footer />
            </div>
          }
        />

        {/* Page de réalisation */}
        <Route path="/realisations" element={<Realisations />} />
        {/* Page admin */}
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Router>
  );
}

export default App;
